export default __webpack_public_path__ + "static/media/HenningH&S.fafb7e2e.png";